module.exports = __webpack_public_path__ + "static/media/matthew-henry.ebe6df30.jpg";